import { useEffect, useState } from 'react'

import { getCategoryUsers } from '_services/data-explorer'

export default function useCategoryUsers(payload) {
  const [result, setResult] = useState()

  useEffect(() => {
    if (payload) {
      getCategoryUsers(payload).then((categoryUsers) => {
        setResult(categoryUsers)
      })
    }
  }, [payload])

  return [result]
}
